import { render, staticRenderFns } from "./billdetail.vue?vue&type=template&id=7af6df0d&scoped=true"
import script from "./billdetail.vue?vue&type=script&lang=js"
export * from "./billdetail.vue?vue&type=script&lang=js"
import style0 from "./billdetail.vue?vue&type=style&index=0&id=7af6df0d&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7af6df0d",
  null
  
)

export default component.exports